import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import CompleteDentalSolutions from './components/CompleteDentalSolutions';
import Features from './components/Features';
import ImageBanner from './components/ImageBanner';
import EmergencyDentalCare from './components/OtherServices';
import Approach from './components/Approach';
import Process from './components/Process';
import GoogleReviews from './components/GoogleReviews';
import ReviewsBanner from './components/ReviewsBanner';
import About from './components/About';
import FAQ from './components/FAQ';
import Contact from './components/Contact';
import FloatingButtons from './components/FloatingButtons';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <Stats />
      <CompleteDentalSolutions />
      <Features />
      <ImageBanner />
      <EmergencyDentalCare />
      <Approach />
      <Process />
      <GoogleReviews />
      <ReviewsBanner />
      <About />
      <FAQ />
      <Contact />
      <Footer />
      <FloatingButtons />
    </div>
  );
}